import { getExpiringAndExpiredDates } from '../../../../backend/utils/getExpiringAndExpiredDates';
import { differenceInMilliseconds, subMilliseconds } from 'date-fns';
const verifiedStatus = 'verified';
export function getManualCredentialVerificationExpirationState(periods, columns) {
    if (columns.jasBoard || columns.status !== verifiedStatus || !columns.requestDate) {
        return { isExpired: false, isExpiring: false };
    }
    const backgroundCheckedAt = new Date(columns.requestDate);
    const { dateWhenExpiring, dateWhenExpired } = getManualCredentialVerificationExpirationDates(periods);
    return {
        isExpiring: !!dateWhenExpiring && backgroundCheckedAt <= dateWhenExpiring,
        isExpired: !!dateWhenExpired && backgroundCheckedAt <= dateWhenExpired,
    };
}
export function getManualCredentialVerificationExpirationDates(periods) {
    return getExpiringAndExpiredDates({
        expiringPeriodDays: periods.manualCredentialVerificationExpiringPeriodDays,
        expiredPeriodDays: periods.manualCredentialVerificationExpiredPeriodDays,
    });
}
export function getManualCredentialVerificationExpirationStorageFilters(periods, options) {
    const { dateWhenExpired, dateWhenExpiring } = getManualCredentialVerificationExpirationDates(periods);
    if (!dateWhenExpiring || !dateWhenExpired) {
        return {
            expiringManualCredentialVerificationFilters: undefined,
            expiredManualCredentialVerificationFilters: undefined,
        };
    }
    const expiringManualCredentialVerificationFilters = [
        ...getCommonFilters(),
        { column: 'requestDate', op: '<=', value: dateWhenExpiring.getTime() },
    ];
    if (!(options === null || options === void 0 ? void 0 : options.treatExpiredAsExpiring)) {
        expiringManualCredentialVerificationFilters.push({
            column: 'requestDate',
            op: '>',
            value: dateWhenExpired.getTime(),
        });
    }
    const expiredManualCredentialVerificationFilters = [
        ...getCommonFilters(),
        { column: 'requestDate', op: '<=', value: dateWhenExpired.getTime() },
    ];
    if (options === null || options === void 0 ? void 0 : options.previousCheckDateToExcludeResults) {
        const msSinceLastCheck = differenceInMilliseconds(new Date(), options.previousCheckDateToExcludeResults);
        expiringManualCredentialVerificationFilters.push({
            column: 'requestDate',
            op: '>=',
            value: subMilliseconds(dateWhenExpiring, msSinceLastCheck).getTime(),
        });
        expiredManualCredentialVerificationFilters.push({
            column: 'requestDate',
            op: '>=',
            value: subMilliseconds(dateWhenExpired, msSinceLastCheck).getTime(),
        });
    }
    return {
        expiringManualCredentialVerificationFilters,
        expiredManualCredentialVerificationFilters,
    };
}
function getCommonFilters() {
    return [
        { column: 'jasBoard', op: '=', value: false },
        { column: 'status', op: '=', value: verifiedStatus },
    ];
}
